import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LibraryMenuModule } from '@modules/library/private/library-menu/library-menu.module';
import { LibraryViewModeModule } from '@modules/library/private/library-view-mode/library-view-mode.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from '@shared-modules/shared.module';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { EditUnitComponent } from './edit-unit.component';
import { FeatureFlagModule } from '@directive/feature-flag/feature-flag.module';
import { HorizonLotEngagementComponent } from '@common/horizon-lot-engagement/horizon-lot-engagement.component';
import { PriceInputModule } from '@common/price-input/price-input.module';

@NgModule({
  declarations: [EditUnitComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgSelectModule,
    RadioButtonModule,
    CalendarModule,
    CheckboxModule,
    LibraryViewModeModule,
    LibraryMenuModule,
    DialogModule,
    SharedModule,
    FeatureFlagModule,
    PriceInputModule,
    HorizonLotEngagementComponent,
  ],
  exports: [EditUnitComponent],
})
export class EditUnitModule {}
